module.exports = __webpack_public_path__ + "static/img/index4.9b3fe7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index4.gif
// module id = 4ec4
// module chunks = 0